.dropdown {
  z-index: 3;
  position: absolute;
  top: 100%;
  left: 0;
  width: 16rem;
}
